<template>
  <div class="wrapper">
    <app-header></app-header>
    <app-sidebar></app-sidebar>
    <div class="content-wrapper">
      <div class="content-nav">
        <navigation></navigation>
      </div>
      <div class="content-view">
        <transition name="fade-transform" mode="out-in">
          <keep-alive>
            <router-view style="height: 100%;" v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
        </transition>
        <transition name="fade-transform" mode="out-in">
          <router-view style="height: 100%;" v-if="!$route.meta.keepAlive"></router-view>
        </transition>
      </div>
    </div>
    <version-check />
  </div>
</template>

<script>
import appHeader from './main/main-header.vue';
import appSidebar from './main/main-sidebar.vue';
import navigation from './utility/navigation-path.vue';
import versionCheck from './utility/version-check.vue'
export default {
  components: {
    'app-header': appHeader,
    'app-sidebar': appSidebar,
    'navigation': navigation,
    'version-check': versionCheck
  },
  name: "main-with-menu",
}
</script>

<style scoped>
.wrapper {
  min-height: 100vh;
  overflow-y: hidden;
}

.content-wrapper {
  background-color: #edf1f5;
}

.content-nav {
  padding-top: 50px;
}

.content-view {
  height: calc(100vh - 96px);
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
}

</style>
<style lang="scss">
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all .3s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-10px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(10px);
}
</style>


// WEBPACK FOOTER //
// src/components/main.vue